<form #employmentFormElement [formGroup]="employmentForm">

  <ng-container *ngIf="isEmployed()">
    <div class="row">
      <section class="data-field col-xl-4">
        <div class="label">
          <span [innerHTML]="'employerCountry' | translate | safe: 'html'"></span>
        </div>

        <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
          <mat-select (selectionChange)="onAddressCountryChanged()"
                      formControlName="employerCountry" name="employercountry">
            <mat-select-trigger>
            <span *ngIf="getCountryCode(employmentModel.employerCountry)" class="ml-auto">
<!--              <img src="/img/flags/{{getCountryCode(employmentModel.employerCountry)}}.png"-->
              <!--                   [default]="'/img/flags/undefined.png'" class="small-flag-icon">-->
            </span>
              <span class="country-info"> {{ getTranslate(employmentModel.employerCountry) }}</span>
            </mat-select-trigger>
            <mat-select-search #employercountrySearch></mat-select-search>
            <mat-option *ngFor=" let country of filterCountryList(countryList, employercountrySearch.filter)"
                        value="{{country.countryName}}">
              <!--              <img src="/img/flags/{{country.countryCode}}.png" [default]="'/img/flags/undefined.png'"-->
              <!--                   class="flag-icon">-->
              <span class="country-info">{{ country.countryTranslation }}</span>
            </mat-option>
          </mat-select>
          <mat-error *ngIf="isRequiredField('employerCountry')">
            {{ 'countryRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>

      <section class="data-field col-xl-4">
        <div class="label">
          <span [innerHTML]="'city' | translate | safe: 'html'"></span>
        </div>

        <mat-form-field [floatLabel]="'always'" appearance="outline">
          <input (change)="updateUser()" class="ltr-text"
                 formControlName="employerCity"
                 matInput
                 maxlength="100"
                 name="employercity" oninput="this.value=this.value.replace(/[^a-zA-Z|-\s]/g,'')"
                 onkeypress="return String.fromCharCode(event.keyCode).match(/\p{L}|-| /u)?true:false">
          <mat-error *ngIf="isRequiredField('employerCity')">
            {{ 'cityRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>

      <div class="w-lg-100"></div>

      <section class="data-field col-xl-4">
        <div class="label">
          <span [innerHTML]="'address' | translate | safe: 'html'"></span>
        </div>

        <mat-form-field [floatLabel]="'always'" appearance="outline">
          <input (change)="updateUser()" class="ltr-text"
                 formControlName="employerAddress"
                 matInput maxlength="200"
                 name="employerAddress" oninput="this.value=this.value.replace(/[^a-zA-Z0-9|-\s]/g,'')">
          <mat-error *ngIf="isRequiredField('employerAddress')">
            {{ 'addressRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>

      <section class="data-field col-xl-4">
        <div class="label">
          <span [innerHTML]="'address2' | translate | safe: 'html'"></span>
        </div>

        <mat-form-field [floatLabel]="'always'" appearance="outline">
          <input formControlName="employerAddress2" matInput
                 maxlength="200"
                 name="address2" oninput="this.value=this.value.replace(/[^a-zA-Z0-9|-\s]/g,'')">

          <mat-error *ngIf="isRequiredField('employerAddress2')">
            {{ 'address2Required' | translate }}
          </mat-error>
        </mat-form-field>
      </section>

      <section class="data-field col-xl-4">
        <div class="label">
          <span [innerHTML]="'postalCode' | translate | safe: 'html'"></span>
        </div>

        <mat-form-field [floatLabel]="'always'" appearance="outline">
          <input (change)="updateUser()" formControlName="employerPostalCode"
                 matInput maxlength="20"
                 name="employerpostalcode" oninput="this.value=this.value.replace(/[^A-Za-z0-9_ ]/g,'')">

          <mat-error *ngIf="isRequiredField('employerPostalCode')">
            {{ 'postalCodeRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>

      <section [ngClass]="{'d-none': employmentModel.employerCountry === 'Israel'}"
               class="data-field col-xl-4">
        <div class="label">
          <span [innerHTML]="'state' | translate | safe: 'html'"></span>
        </div>

        <mat-form-field appearance="outline" class="info select">
          <mat-select (selectionChange)="updateUser()" disableOptionCentering
                      formControlName="employerState" name="state">
            <mat-select-trigger>
        <span class="country-info">
          {{ getStateName(employmentModel.employerCountry, employmentModel.state) }}</span>
            </mat-select-trigger>
            <mat-option *ngFor="let state of getStatesByCountry(employmentModel.employerCountry)"
                        value="{{state.code}}">
              <span class="country-info">{{ state.name }}</span>
            </mat-option>
          </mat-select>

          <mat-error *ngIf="isRequiredField('employerState')">
            {{ 'stateRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>

      <section class="col-12">
        <div *ngIf="!isCorrectEmployerAddress()" class="warning-info">
          <i class="fa fa-warning"></i>
          <div [translate]="'incorrectEmployerAddress'" class="small"></div>
        </div>
      </section>

      <ng-container *ngIf="isRequiredCountryDetails()">
        <h1 [translate]="'regulatoryInformation'" class="header"></h1>
        <div class="row">
          <section class="col-xl-12">
            <p
              [translateParams]="{addressCountry: getTranslate(addressModel.countryName), employerCountry: getTranslate(employmentModel.employerCountry)}"
              [translate]="'rescountryDetails'"
              class="additional-info"></p>
          </section>
          <section class="data-field col-xl-12">
            <div class="label">
              <span [innerHTML]="'details' | translate | safe: 'html'"></span>
            </div>

            <mat-form-field [floatLabel]="'always'" appearance="outline">
              <input (change)="updateUser()"
                     formControlName="employerCountryDetails"
                     matInput
                     maxlength="200" name="employerCountryDetails"
                     oninput="this.value=this.value.replace(/[^A-Za-z0-9'\.\-\\\/\s\,]/g,'')">
              <mat-error *ngIf="isRequiredField('employerCountryDetails')">
                {{ 'rescountryDetailsRequired' | translate }}
              </mat-error>
            </mat-form-field>
          </section>
        </div>
      </ng-container>
    </div>
  </ng-container>

</form>
